export default __webpack_public_path__ + "static/media/sticker-pa.9829141c.png";